export default __webpack_public_path__ + "static/google_avis-d45456d72dc3fc31493b88e9ff3951ed.png";